import { useEffect, useRef } from 'react';
import { createPortal } from 'react-dom';
const Portal = (props) => {
    const { children, container = document.body } = props;
    const el = useRef(document.createElement('div'));
    useEffect(() => {
        // no container, skip render
        if (!container) {
            return undefined;
        }
        container.appendChild(el.current);
        return () => {
            container.removeChild(el.current);
        };
    }, []);
    return createPortal(children, el.current);
};
export default Portal;
